import { TitleCasePipe } from '@angular/common';
import { EventEmitter } from '@angular/core';
import { Component, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ApplicationBaseComponent } from '../../../../../applications/components/application-base.component';
import { ApplicationSectionBaseComponent } from '../../../../../applications/components/application-section-base/application-section-base.component';
import { ApplicationState, ApplicationType, InitiateWorkflowRequest, WorkflowData } from '../../../../../applications/models/applications.models';
import { ApplicationNotesService } from '../../../../../applications/services/application-notes.service';
import { ApplicationsService } from '../../../../../applications/services/applications.service';
import { DomainDefinitionService } from '../../../../../builder/services/domain-definition.service';
import { LoaderService } from '../../../../../common/services/loader.service';
import { SidePanelService } from '../../../../../common/services/side-panel.service';
import { WellService } from '../../../../../common/services/well.service';
import { Dialog, DialogButton } from '../../../../../core/models/dialog.model';
import { DynamicDialogService } from '../../../../../core/services/dynamic-dialog.service';
import { SubHeaderService } from '../../../../../core/services/sub-header.service';
import { ApplicationConfigService } from '../../../../../services/application-config.service';
import { AuthService } from '../../../../../services/auth.service';
import { ComplianceReportingType } from '../../../../models/compliance.model';

@Component({
    selector: 'app-certification',
    templateUrl: './certification.component.html',
    styleUrls: ['./certification.component.scss', '../../../../../core/components/collapsible/collapsible.component.scss'],
    standalone: false
})
export class CertificationComponent extends ApplicationSectionBaseComponent implements OnInit {

    @Input() form: FormGroup;
    @Input() reportType: ComplianceReportingType;
    @Input() application: WorkflowData;

    reviewStates: ApplicationState[] = [
        ApplicationState.VerifyCompletion,
        ApplicationState.InitialReview,
        ApplicationState.InitialApproval,
        ApplicationState.FinalApproval
    ];

    constructor(auth: AuthService, private domainService: DomainDefinitionService, public router: Router) { super(auth) }


}
